import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { SortDirection } from "@redotech/redo-views-common/table";
import * as z from "zod";
import { ItemWorkRequestTableRowSchema } from "./item-work-request-types";

export const searchItemWorkRequests = {
  name: "searchItemWorkRequests" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    search: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: z.enum(SortDirection) })
      .nullish(),
    filterGroup: FilterGroupSchema.optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
  }),
  output: z.object({ requests: z.array(ItemWorkRequestTableRowSchema) }),
};

export const getItemWorkRequestsCount = {
  name: "getItemWorkRequestsCount" as const,
  input: z.object({
    search: z.string().optional(),
    filterGroup: FilterGroupSchema.optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
  }),
  output: z.object({ total: z.number() }),
};
